// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const styles = css`
  padding: 65px 0;
  .image-zoom {
    overflow-x: hidden;
    width: 100%;
    padding-bottom: 0px;
  }

  img {
    width: 100%;
  }

  .active-zoom-in {
    &.image-zoom {
      margin: 0px -27px;
      transform: scale(1.5);
    }
    & > img {
      display: block;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      width: 150%;
      max-width: none;
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .close-modal.alignTop {
      top: 10px;
      height: 22px;
      width: 22px;
      right: 15px;
    }
  }
  .pdp-img-overlay {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 154%;
    transform-origin: 0 0;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      padding-top: 120%;
    }
  }
  .pdp-img-overlay .product-img-slider {
    position: absolute;
    width: 94%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media screen and (orientation: landscape) {
    .pdp-img-overlay {
      padding-top: 62%;
    }
    .pdp-img-overlay .product-img-slider {
      width: 45%;
    }
  }
  @media screen and (max-height: 430px) and (orientation: landscape) {
    .pdp-img-overlay {
      padding-top: 31%;
    }
    .pdp-img-overlay .product-img-slider {
      width: 22%;
    }
  }

  .pdp-img-overlay .product-img-slider .slick-initialized {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      overflow: hidden;
    }
  }

  .new-image-dots-pdp {
    ${(props) => `
    width: ${props.theme.spacing.ELEM_SPACING.XS_6};
    height: ${props.theme.spacing.ELEM_SPACING.XS_6};
    background: rgb(87, 87, 87);
    margin-right: 3px;
    border-radius: 50%;
    display: inline-block;
    `}
  }

  .new-image-dots-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    padding: 0;
    align-items: center;

    ul {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    li {
      display: inline-block;
      position: relative;
      margin: 0 2px;
      width: 6px;
      height: 6px;
      padding-right: 36px;
    }
    li div:before {
      ${(props) =>
        `content: '';
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          width: ${props.theme.spacing.ELEM_SPACING.XXXL};
          height: ${props.theme.spacing.ELEM_SPACING.XXXS};
          border-radius: ${props.theme.spacing.ELEM_SPACING.XXS};
          background: ${props.theme.colors.PRIMARY.LIGHTGRAY};`}
    }
    li.image-active div:before {
      ${(props) =>
        `width: 48px;height: 2px;background:${props.theme.colors.WHITE};border: 1px solid ${props.theme.colors.PRIMARY.DARK};`}
    }
  }

  .color-selector {
    font-family: Nunito, Arial, Helvetica, sans-serif;
    cursor: auto;
    width: 100%;
  }
  .color-image {
    position: relative;
    width: 50px;
    height: 55px;
    cursor: pointer;
    border: none;
    background-color: rgb(255, 255, 255);
    border-radius: 8px;
  }
  .color-title-container {
    margin-right: 14px;
  }

  .color-title-container-selected {
    width: 50px;
    height: 55px;
    flex-grow: 0;
    padding: 2px;
    border-radius: 6px;
    border: solid 3px #4b9fdd;
    display: inline-block;
  }

  .image-chips-selector-items-list {
    overflow: scroll hidden;
    width: 100%;
    white-space: nowrap;
  }
`;

export const ZoomPreventWrapper = styled.div`
  height: 10vh;
`;

export default styles;
